var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRaw = function SvgRaw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.5 10.5 18 6h4.5zM4.5 13h13.6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 2.1,
    y: 11,
    fill: "#21852B",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.273 17.5v-4h1.578q.453 0 .774.162.322.16.49.455.17.293.17.69 0 .398-.172.685-.172.285-.498.438a1.8 1.8 0 0 1-.785.152H4.773v-.68h.92q.241 0 .402-.066a.48.48 0 0 0 .239-.2.63.63 0 0 0 .08-.33.66.66 0 0 0-.08-.335.5.5 0 0 0-.24-.207 1 1 0 0 0-.405-.073h-.57V17.5zm2.16-1.82.994 1.82h-.933l-.973-1.82zm2.304 1.82H7.83l1.38-4h1.09l1.38 4h-.907l-1.002-3.086h-.031zm-.057-1.572h2.14v.66H8.68zm4.144 1.572-1.144-4h.924l.662 2.78h.033l.73-2.78h.791l.729 2.785h.035l.662-2.785h.924l-1.145 4h-.824l-.762-2.615h-.03l-.76 2.615z"
  })));
};
export default SvgRaw;